import { DeltaBadge } from "./DeltaBadge";

export function KpiCard({
  title,
  value,
  icon: Icon,
  delta,
  deltaSuffix = "%",
  deltaInvert = false,
  footer,
  children,
  testId,
}) {
  return (
    <div
      data-testid={testId}
      className="rounded-md border border-border bg-card p-6 transition-colors hover:border-primary/40"
    >
      <div className="flex items-center justify-between">
        <span className="text-xs uppercase tracking-widest text-muted-foreground">
          {title}
        </span>
        {Icon && <Icon className="h-4 w-4 text-muted-foreground" />}
      </div>
      <div className="mt-3 font-num text-2xl font-semibold leading-none text-foreground">
        {value}
      </div>
      {(delta !== undefined || footer) && (
        <div className="mt-3 flex items-center gap-2">
          {delta !== undefined && (
            <DeltaBadge value={delta} suffix={deltaSuffix} invert={deltaInvert} />
          )}
          {footer && <span className="text-xs text-muted-foreground">{footer}</span>}
        </div>
      )}
      {children && <div className="mt-3">{children}</div>}
    </div>
  );
}
